import './styles.scss';

import React, { Component } from 'react';

export default class CustomersHero extends Component {
    static propTypes = {};

    render() {
        return (
            <div className="component-contact-hero">
                <div className="content container-fluid v2 medium">
                    <div className="content-col content-col-left">
                        <h2 className="section-subtitle">
                            REAL PEOPLE. REAL PASSION. REAL RESULTS.
                        </h2>
                        <p className="section-text">
                            Learn more about who we are and what we stand for.
                        </p>
                        <div className="section-subdesc">
                            <img className="section-subdesc-image" src={require('./images/contact-hero-sec-bg.svg')} />
                            <p className="section-subdesc-content">
                                We are a community of 3m creatives telling real and engaging brand stories. 
                                We are curators and legal experts backed by real passion and real results. 
                                We are you: creative professionals in pursuit of authentic visual content that performs for your brand - 
                                and nothing but. We are Foap: your customised visual-content platform powered by creatives for creative professionals.
                            </p>
                        </div>
                    </div>
                    <div className="content-col content-col-right">
                        <img src={require('./images/contact-hero-main.svg')} />
                    </div>
                </div>
                <img className="section-bg" src={require('./images/contact-hero-bg.svg')} />
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/public/contact/Hero/index.js